// extracted by mini-css-extract-plugin
export default {"SecondaryButton":"ModalStyles_SecondaryButton__5C3Fq","PrimaryButton":"ModalStyles_PrimaryButton__-klmv","DropdownButtonPrimary":"ModalStyles_DropdownButtonPrimary__ELXrS"};